import axios from "axios";

import * as actionTypes from "./actionTypes";
import { loading, searchLoading } from "./commonAc";

let domainUserDetails = process.env.REACT_APP_API2_URL;

export const loadingRefreshSet = (data) => {
  return {
    type: actionTypes.REFRESH_LOADING,
    data: data,
  };
};

export const optionsTableLoading = (increment) => {
  return {
    type: actionTypes.OPTIONS_TABLE_LOADING,
    data: increment,
  };
};

export const optionsInitialLoading = (increment) => {
  return {
    type: actionTypes.OPTIONS_INITIAL_LOADING,
    data: increment,
  };
};

const isOptionsFirstLoad = (obj) => Boolean(obj.isInitialLoad);

const beginOptionsListLoad = (dispatch, obj, isFirstLoad) => {
  if (obj.isPageChange) {
    dispatch(optionsTableLoading(true));
    return;
  }
  if (obj.onLoad && !obj.isInfiniteLoad) dispatch(loading(true));
  if (obj.isRefresh) dispatch(loadingRefreshSet(true));
  if (isFirstLoad) dispatch(optionsInitialLoading(true));
};

const beginCompanyTableLoad = (dispatch, obj, isFirstLoad) => {
  if (obj.isRefresh) dispatch(loadingRefreshSet(true));
  if (obj.isPageChange) {
    dispatch(optionsTableLoading(true));
    return;
  }
  if (obj.onLoad) {
    dispatch(loading(true));
    dispatch(optionsTableLoading(true));
    if (isFirstLoad) dispatch(optionsInitialLoading(true));
  }
};

const finishOptionsTableLoad = (dispatch, obj, isFirstLoad) => {
  if (obj.onLoad || obj.isPageChange) dispatch(optionsTableLoading(false));
  if (!obj.isPageChange) {
    dispatch(loading(false));
    dispatch(loadingRefreshSet(false));
  }
  if (isFirstLoad) dispatch(optionsInitialLoading(false));
};

const finishOptionsListLoad = (dispatch, obj, isFirstLoad) => {
  if (obj.isPageChange) {
    dispatch(optionsTableLoading(false));
    return;
  }
  dispatch(loading(false));
  dispatch(loadingRefreshSet(false));
  if (isFirstLoad) dispatch(optionsInitialLoading(false));
};

export const getOptionsOpenInterestDataDone = (data) => {
  return {
    type: actionTypes.GET_OPTIONS_OPEN_INTEREST_DATA_DONE,
    data: data,
  };
};

export const getOptionsBlockQuantityDataDone = (data) => {
  return {
    type: actionTypes.GET_OPTIONS_BLOCK_QUANTITY_DATA_DONE,
    data: data,
  };
};

export const getOptionsBlockQualityDataDone = (data) => {
  return {
    type: actionTypes.GET_OPTIONS_BLOCK_QUALITY_DATA_DONE,
    data: data,
  };
};

export const getOptionsIvChangeDataDone = (data) => {
  return {
    type: actionTypes.GET_IV_CHANGE_DATA_DONE,
    data: data,
  };
};

export const getOptionsAverageVolDataDone = (data) => {
  return {
    type: actionTypes.GET_OPTIONS_AVERAGE_VOLUME_DATA_DONE,
    data: data,
  };
};

export const getTerritoryDataDone = (data) => {
  return {
    type: actionTypes.GET_TERRITORY_DATA_DONE,
    data: data,
  };
};

export const getInterestDataDone = (data) => {
  return {
    type: actionTypes.GET_OPTIONS_INTEREST_DATA_DONE,
    data: data,
  };
};

export const getMomentumDataDone = (data) => {
  return {
    type: actionTypes.GET_MOMENTUM_DATA_DONE,
    data: data,
  };
};

export const getExposureDataDone = (data) => {
  return {
    type: actionTypes.GET_EXPOSURE_DATA_DONE,
    data: data,
  };
};

export const getOptionsSearchDataDone = (data) => {
  return {
    type: actionTypes.GET_OPTIONS_SEARCH_DATA_DONE,
    data: data,
  };
};

export const setShowFaq = (value) => {
  return {
    type: actionTypes.SHOW_FAQ,
    data: value,
  };
};

export const getOptionsOpenInterestData = (obj) => {
  return (dispatch, getState) => {
    const isFirstLoad = isOptionsFirstLoad(obj);
    beginOptionsListLoad(dispatch, obj, isFirstLoad);

    const params = {
      limit: obj.limit,
      offset: obj.offset,
      tags: obj.tags ? obj.tags : "",
      start: obj.start ? obj.start : "",
      end: obj.end ? obj.end : "",
      cids: obj.cids ? obj.cids : "",
      bids: "",
      action: "all",
      sortby: obj.sortby ? obj.sortby : "",
      sortorder: obj.sortorder ? obj.sortorder : "",
    };

    axios
      .get(`${domainUserDetails}/v3/options-open-interest`, { params })
      .then((res) => {
        let data = res.data;
        if (!obj.onLoad && obj.isInfiniteLoad) {
          let prevData = getState().options.optionOpenInterestData.data;
          let appendedData = prevData.concat(data.data);
          data.data = appendedData;
        }
        let element = document.getElementById("tableScroll");
        if (element) element.scrollTop = 0;
        dispatch(getOptionsOpenInterestDataDone(data));
        finishOptionsListLoad(dispatch, obj, isFirstLoad);
      })
      .catch(() => {
        finishOptionsListLoad(dispatch, obj, isFirstLoad);
      });
  };
};

export const getOptionsBlockQuantityData = (obj) => {
  return (dispatch, getState) => {
    const isFirstLoad = isOptionsFirstLoad(obj);
    beginOptionsListLoad(dispatch, obj, isFirstLoad);

    const params = {
      limit: obj.limit,
      offset: obj.offset,
      tags: obj.tags ? obj.tags : "",
      start: obj.start ? obj.start : "",
      end: obj.end ? obj.end : "",
      cids: obj.cids ? obj.cids : "",
      bids: "",
      action: "all",
      sortby: obj.sortby ? obj.sortby : "",
      sortorder: obj.sortorder ? obj.sortorder : "",
    };

    axios
      .get(`${domainUserDetails}/v3/options-block-quantity`, { params })
      .then((res) => {
        let data = res.data;
        if (!obj.onLoad && obj.isInfiniteLoad) {
          let prevData = getState().options.optionsBlockQuantityData.data;
          let appendedData = prevData.concat(data.data);
          data.data = appendedData;
        }
        let element = document.getElementById("tableScroll");
        if (element) element.scrollTop = 0;
        dispatch(getOptionsBlockQuantityDataDone(data));
        finishOptionsListLoad(dispatch, obj, isFirstLoad);
      })
      .catch(() => {
        finishOptionsListLoad(dispatch, obj, isFirstLoad);
      });
  };
};

export const getOptionsBlockQualityData = (obj) => {
  return (dispatch, getState) => {
    const isFirstLoad = isOptionsFirstLoad(obj);
    beginOptionsListLoad(dispatch, obj, isFirstLoad);

    const params = {
      limit: obj.limit,
      offset: obj.offset,
      tags: obj.tags ? obj.tags : "",
      start: obj.start ? obj.start : "",
      end: obj.end ? obj.end : "",
      cids: obj.cids ? obj.cids : "",
      bids: "",
      action: "all",
      sortby: obj.sortby ? obj.sortby : "",
      sortorder: obj.sortorder ? obj.sortorder : "",
    };

    axios
      .get(`${domainUserDetails}/v3/options-block-quality`, { params })
      .then((res) => {
        let data = res.data;
        if (!obj.onLoad && obj.isInfiniteLoad) {
          let prevData = getState().options.optionsBlockQualityData.data;
          let appendedData = prevData.concat(data.data);
          data.data = appendedData;
        }
        let element = document.getElementById("tableScroll");
        if (element) element.scrollTop = 0;
        dispatch(getOptionsBlockQualityDataDone(data));
        finishOptionsListLoad(dispatch, obj, isFirstLoad);
      })
      .catch(() => {
        finishOptionsListLoad(dispatch, obj, isFirstLoad);
      });
  };
};

export const getOptionsIvChangeData = (obj) => {
  return (dispatch, getState) => {
    const isFirstLoad = isOptionsFirstLoad(obj);
    beginOptionsListLoad(dispatch, obj, isFirstLoad);

    const params = {
      limit: obj.limit,
      offset: obj.offset,
      tags: obj.tags ? obj.tags : "",
      start: obj.start ? obj.start : "",
      end: obj.end ? obj.end : "",
      cids: obj.cids ? obj.cids : "",
      bids: "",
      action: "all",
      sortby: obj.sortby ? obj.sortby : "",
      sortorder: obj.sortorder ? obj.sortorder : "",
    };

    axios
      .get(`${domainUserDetails}/v3/options-iv-change`, { params })
      .then((res) => {
        let data = res.data;
        if (!obj.onLoad && obj.isInfiniteLoad) {
          let prevData = getState().options.optionsIvData.data;
          let appendedData = prevData.concat(data.data);
          data.data = appendedData;
        }
        let element = document.getElementById("tableScroll");
        if (element) element.scrollTop = 0;
        dispatch(getOptionsIvChangeDataDone(data));
        finishOptionsListLoad(dispatch, obj, isFirstLoad);
      })
      .catch(() => {
        finishOptionsListLoad(dispatch, obj, isFirstLoad);
      });
  };
};

export const getOptionsAverageVolData = (obj) => {
  return (dispatch, getState) => {
    const isFirstLoad = isOptionsFirstLoad(obj);
    beginOptionsListLoad(dispatch, obj, isFirstLoad);

    const params = {
      limit: obj.limit,
      offset: obj.offset,
      tags: obj.tags ? obj.tags : "",
      start: obj.start ? obj.start : "",
      end: obj.end ? obj.end : "",
      cids: obj.cids ? obj.cids : "",
      bids: "",
      action: "all",
      sortby: obj.sortby ? obj.sortby : "",
      sortorder: obj.sortorder ? obj.sortorder : "",
    };

    axios
      .get(`${domainUserDetails}/v3/options-quantity-average-volume`, {
        params,
      })
      .then((res) => {
        let data = res.data;
        if (!obj.onLoad && obj.isInfiniteLoad) {
          let prevData = getState().options.optionsAverageVolData.data;
          let appendedData = prevData.concat(data.data);
          data.data = appendedData;
        }
        let element = document.getElementById("tableScroll");
        if (element) element.scrollTop = 0;
        dispatch(getOptionsAverageVolDataDone(data));
        finishOptionsListLoad(dispatch, obj, isFirstLoad);
      })
      .catch(() => {
        finishOptionsListLoad(dispatch, obj, isFirstLoad);
      });
  };
};

export const getTerritoryData = (obj) => {
  return (dispatch) => {
    const isFirstLoad = isOptionsFirstLoad(obj);
    beginCompanyTableLoad(dispatch, obj, isFirstLoad);

    const params = {
      cid: obj.cid,
      date: obj.date,
      tags: obj.tags,
      start: obj.start,
      // sortby: obj.sortby ? obj.sortby : "",
      // sortorder: obj.sortorder ? obj.sortorder : "",
    };

    axios
      .get(`${domainUserDetails}/v3/options/time`, {
        params,
      })
      .then((res) => {
        let data = res.data;
        // if (!obj.onLoad) {
        //   let prevData = getState().options.territoryData.data;
        //   let appendedData = prevData.concat(data.data);
        //   data.data = appendedData;
        // }
        let element = document.getElementById("tableScroll");
        if (element) element.scrollTop = 0;
        dispatch(getTerritoryDataDone(data));
        finishOptionsTableLoad(dispatch, obj, isFirstLoad);
      })
      .catch(() => {
        finishOptionsTableLoad(dispatch, obj, isFirstLoad);
      });
  };
};

export const getOptionsInterestData = (obj) => {
  return (dispatch) => {
    const isFirstLoad = isOptionsFirstLoad(obj);
    beginCompanyTableLoad(dispatch, obj, isFirstLoad);

    const params = {
      cid: obj.cid,
      date: obj.date,
      start: obj.start,
      // sortby: obj.sortby ? obj.sortby : "",
      // sortorder: obj.sortorder ? obj.sortorder : "",
    };

    axios
      .get(`${domainUserDetails}/v3/options/interests`, {
        params,
      })
      .then((res) => {
        let data = res.data;
        // if (!obj.onLoad) {
        //   let prevData = getState().options.interestsData.data;
        //   let appendedData = prevData.concat(data.data);
        //   data.data = appendedData;
        // }
        let element = document.getElementById("tableScroll");
        if (element) element.scrollTop = 0;
        dispatch(getInterestDataDone(data));
        finishOptionsTableLoad(dispatch, obj, isFirstLoad);
      })
      .catch(() => {
        finishOptionsTableLoad(dispatch, obj, isFirstLoad);
      });
  };
};

export const getMomentumData = (obj) => {
  return (dispatch) => {
    const isFirstLoad = isOptionsFirstLoad(obj);
    beginCompanyTableLoad(dispatch, obj, isFirstLoad);

    const params = {
      limit: obj.limit,
      offset: obj.offset,
      cid: obj.cid,
      date: obj.date,
      start: obj.start,
      sortby: obj.sortby ? obj.sortby : "",
      sortorder: obj.sortorder ? obj.sortorder : "",
    };

    axios
      .get(`${domainUserDetails}/v3/options/momentum`, {
        params,
      })
      .then((res) => {
        let data = res.data;
        // if (!obj.onLoad) {
        //   let prevData = getState().options.momentumData.data;
        //   let appendedData = prevData.concat(data.data);
        //   data.data = appendedData;
        // }
        let element = document.getElementById("tableScroll");
        if (element) element.scrollTop = 0;
        dispatch(getMomentumDataDone(data));
        finishOptionsTableLoad(dispatch, obj, isFirstLoad);
      })
      .catch(() => {
        finishOptionsTableLoad(dispatch, obj, isFirstLoad);
      });
  };
};

export const getExposureData = (obj) => {
  return (dispatch, getState) => {
    const isFirstLoad = isOptionsFirstLoad(obj);
    beginCompanyTableLoad(dispatch, obj, isFirstLoad);

    const params = {
      limit: obj.limit,
      offset: obj.offset,
      cid: obj.cid,
      expiration: obj.expiration,
      type: obj.type,
      strike: obj.strike,
      sortby: obj.sortby ? obj.sortby : "",
      sortorder: obj.sortorder ? obj.sortorder : "",
    };

    axios
      .get(`${domainUserDetails}/v3/options/exposure`, {
        params,
      })
      .then((res) => {
        let data = res.data;
        // if (!obj.onLoad) {
        //   let prevData = getState().options.exposureData.data;
        //   let appendedData = prevData.concat(data.data);
        //   data.data = appendedData;
        // }
        let element = document.getElementById("tableScroll");
        if (element) element.scrollTop = 0;
        dispatch(getExposureDataDone(data));
        finishOptionsTableLoad(dispatch, obj, isFirstLoad);
      })
      .catch(() => {
        finishOptionsTableLoad(dispatch, obj, isFirstLoad);
      });
  };
};

let cancelToken;

export const getOptionsSearchData = (obj) => {
  return (dispatch) => {
    dispatch(searchLoading(true));

    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    axios
      .get(
        domainUserDetails +
          `/v3/options/search?search=${obj.search}&tags=${obj.tags}`,
        {
          cancelToken: cancelToken.token,
        }
      )
      .then((res) => {
        let data = res.data;
        dispatch(getOptionsSearchDataDone(data?.company));
        dispatch(searchLoading(false));
      })
      .catch((err) => {
        // console.log(err);
      });
  };
};
